import { createSelector } from 'reselect'
import { difference, filter, times } from 'lodash'
import { DateTime } from 'luxon'

import { ReduxState } from '../utils/typeHelpers'
import { DATE_FORMATS_LUXON } from '../utils/dateHelpers'

export const getAllocationRules = (state: ReduxState) => state.allocationRules

export const getAllocationRuleArray = createSelector(
  [getAllocationRules],
  (allocationRules) => Object.values(allocationRules)
)

export const getAllocationGuides = (state: ReduxState) =>
  state.allocationGuides.byId

export const getAllocationGuideById = createSelector(
  [
    getAllocationGuides,
    (_: unknown, allocationGuideId: number | string | undefined) =>
      allocationGuideId,
  ],
  (allocationGuides, allocationGuideId) =>
    allocationGuideId ? allocationGuides[Number(allocationGuideId)] : undefined
)

export const selectMissingAllocationGuides = createSelector(
  getAllocationGuides,
  (guides) => {
    const neededMonths = times(12).map((value) =>
      DateTime.now()
        .minus({ months: value })
        .toFormat(DATE_FORMATS_LUXON.YEAR_MONTH)
    )
    const allocationGuideMonths = Object.values(guides).map(
      (guide) => guide.date
    )
    return difference(neededMonths, allocationGuideMonths)
  }
)

/*
  Admin Allocation Guide Selectors
*/

export const adminGetUserAllocationGuides = createSelector(
  [getAllocationGuides, (_: unknown, userId: number) => userId],
  (allocationGuides, userId) =>
    filter(allocationGuides, (guide) => guide.userId === userId)
)

/*

  Admin allocation rule selectors
*/

export const adminGetUserAllocationRules = createSelector(
  [getAllocationRules, (_: unknown, userId: number) => userId],
  (allocationRules, userId) =>
    filter(allocationRules, (rule) => rule.userId === userId)
)
